import axiosInstance from "./axiosInstance";
import { TeachersForClass } from "../types/planningTypes";
import { ApiResponse } from "../types/apiTypes";
import { ClassForTeacher } from "../types/classTaskTypes";

/**
 * Fetch class subjects based on classIds or teacherIds.
 * @param classIds - Array of class IDs to filter by (optional).
 * @param teacherIds - Array of teacher IDs to filter by (optional).
 * @returns Promise<ClassSubjectResponse>
 */
export const fetchClassSubjects = async (params: { teacherIds?: string[]; classIds?: string[] }) => {
  if (params.teacherIds) {
    const response = await axiosInstance.get<ApiResponse<ClassForTeacher[]>>(`/class-subjects`, { params });
    return response.data.data;
  } else if (params.classIds) {
    const response = await axiosInstance.get<ApiResponse<TeachersForClass[]>>(`/class-subjects`, { params });
    return response.data.data;
  }
};


export const assignTeacherToClass = async (body: { teacherId: string; classSubjectId: string }) => {
    const response = await axiosInstance.post<ApiResponse<ClassForTeacher[]>>(`/class-subjects/assign-teacher`, body);
    return response.data.data;
};